var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnOptimizationServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "circle",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-Optimization-Services",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#circle)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "circle-2",
    "data-name": "circle",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dots",
    transform: "translate(9.236 5.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16132",
    "data-name": "Group 16132",
    transform: "translate(0 13.653)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1262",
    "data-name": "Ellipse 1262",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(13.539 51.341)",
    fill: "#e7e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(4.832)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(0 27.552)",
    fill: "#97d3f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16131",
    "data-name": "Group 16131",
    transform: "translate(30.922)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1265",
    "data-name": "Ellipse 1265",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(18.824 63.153)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1266",
    "data-name": "Ellipse 1266",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(27.398 31.535)",
    fill: "#97d3f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1267",
    "data-name": "Ellipse 1267",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    fill: "#e7e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19000",
    "data-name": "Group 19000",
    transform: "translate(16.325 17.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25518",
    "data-name": "Path 25518",
    d: "M58.255,44.646l-4.034-.982c.941-1.253,1.779-2.457,2.725-3.57a1.635,1.635,0,0,1,1.258-.413,13.494,13.494,0,0,0,11.209-3.393,13.171,13.171,0,0,0,4.1-14.106A13.015,13.015,0,0,0,62.831,12.4c-5.687-1.081-10.324.946-13.833,5.542-.261.342-.493.705-.606.867l-4.462-1.835L45.4,14.511c-.632-.581-1.351-1.184-2-1.852a2.39,2.39,0,0,1-.154-3.488,2.432,2.432,0,0,1,3.581.139c.625.6,1.221,1.235,1.842,1.866a37.08,37.08,0,0,1,3.517-2,20.632,20.632,0,0,1,4.361-1.462c1.074-.205,1.41-.6,1.279-1.6a10.771,10.771,0,0,1-.008-1.285c-1.7-.063-3.587.238-4.055-1.989C53.474,1.461,54.291.621,55.4,0h9.738C66.3.573,67.11,1.395,66.85,2.792c-.437,2.348-2.4,1.965-4.148,2.06a14.908,14.908,0,0,0,.027,1.971.979.979,0,0,0,.575.7,19.606,19.606,0,0,1,8.6,3.822c.636-.726,1.218-1.48,1.894-2.139a2.392,2.392,0,1,1,3.385,3.374c-.654.685-1.379,1.3-1.924,1.812.954,1.987,1.906,3.761,2.66,5.614a29.162,29.162,0,0,1,1,3.746v4.275a5,5,0,0,0-.213.656c-1.451,7.942-6.069,13.046-13.787,15.357-.859.257-1.75.41-2.626.611Z",
    transform: "translate(-32.456)",
    fill: "#007dba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25519",
    "data-name": "Path 25519",
    d: "M9.41,111.748A2.505,2.505,0,0,1,8.2,109.583c-.048-.713-.279-1.293-1.093-1.466a1.582,1.582,0,0,1-.726-.387,2.645,2.645,0,0,0-3.407-.45,1.173,1.173,0,0,1-.8.071C.788,106.965.409,105.669.033,104.57A2.337,2.337,0,0,1,.846,102.7a2.24,2.24,0,0,0,.983-2.4,2.847,2.847,0,0,1,.017-1.3,1.5,1.5,0,0,0-.7-1.692,2.844,2.844,0,0,1,.649-4.777,3.291,3.291,0,0,1,2.012.207,1.536,1.536,0,0,0,1.825-.256,1.718,1.718,0,0,1,.693-.447A2.638,2.638,0,0,0,8.345,89.4,1.541,1.541,0,0,1,10.106,88c.514,0,1.028,0,1.542,0a1.611,1.611,0,0,1,1.769,1.549,2.252,2.252,0,0,0,1.718,2.318,2.155,2.155,0,0,1,.9.557,1.586,1.586,0,0,0,1.924.285,2.847,2.847,0,0,1,3.8,2.955,2.726,2.726,0,0,1-1.012,1.492,1.8,1.8,0,0,0-.859,2,1.594,1.594,0,0,1,.023.708,2.608,2.608,0,0,0,1.235,3,1.558,1.558,0,0,1,.412,2.214c-.221.419-.478.819-.705,1.234a1.679,1.679,0,0,1-2.387.859,2.167,2.167,0,0,0-2.777.321,1.787,1.787,0,0,1-.821.457c-1.034.237-1.183,1.022-1.431,1.889a8.107,8.107,0,0,1-1.171,1.91Zm1.414-8.491a3.4,3.4,0,1,0-3.362-3.4,3.336,3.336,0,0,0,3.362,3.4",
    transform: "translate(0 -67.102)",
    fill: "#2fa2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25520",
    "data-name": "Path 25520",
    d: "M104.525,84.209a3.676,3.676,0,0,1,3.362-3.648,3.156,3.156,0,0,0,1.47-.565c1.423-1.065,2.8-2.191,4.176-3.32.764-.627,1.557-.894,2.309-.1a1.547,1.547,0,0,1-.115,2.237c-.973,1.2-1.9,2.426-2.9,3.6a4.642,4.642,0,0,0-1.133,2.509,3.543,3.543,0,0,1-3.836,2.96,3.658,3.658,0,0,1-3.333-3.672",
    transform: "translate(-79.702 -58.016)",
    fill: "#2fa2d9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnOptimizationServices);
export default __webpack_public_path__ + "static/media/icn-Optimization-Services.d7625259246ab3462c100d2b9854e429.svg";
export { ForwardRef as ReactComponent };